import React from "react";
import styled from "styled-components";
import {TypeOfItem} from "../../types";

const DoubleContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})<{isDrag?: boolean; size: number}>`
    position: relative;
    height: ${({size}) => size}px;
    width: ${({size}) => size}px;
`;

const WrapperComponent = styled.div<{fromTop: number}>`
    position: absolute;
    top: ${({fromTop}) => fromTop}px;
`;

interface Props {
    size: number;
    count: number;
    component: ({size, typeOfItem}: { size: number; typeOfItem: TypeOfItem }) => JSX.Element;
    isDrag?: boolean;
    typeOfItem: TypeOfItem;
}

export const BaseItemCol = ({size, count, component: Component, isDrag, typeOfItem}: Props) => {
    return (
        <DoubleContainer size={size} isDrag={isDrag}>
            {Array(count).fill('').map((_, index) => (
                <WrapperComponent key={index} fromTop={size * index}>
                    <Component typeOfItem={typeOfItem} size={size} />
                </WrapperComponent>
            ))}
        </DoubleContainer>
    )
}
